<ul class="nav navbar-nav">
  <li class="nav-item d-none d-lg-block">
    <!-- Bookmark Icon -->
    <a
      placement="bottom"
      ngbTooltip="{{ 'Dash.gservF' | translate }}"
      class="nav-link bookmark-star"
      (click)="toggleBookmarkPopup()"
      ><span [data-feather]="'star'" [class]="'ficon text-warning'"></span
    ></a>
    <!--/ Bookmark Icon -->

    <!-- Bookmark Pop-up -->
    <div class="bookmark-input search-input" [class.show]="openBookmarkRef">
      <div class="ml-2 mt-2">
        <span>{{ "Global.fav" | translate }}</span>
      </div>
      <!-- <div class="bookmark-input-icon"><span [data-feather]="'search'"></span></div> -->
      <input
        class="form-control input"
        type="text"
        placeholder="Bookmark"
        #openBookmark
        tabindex="0"
        data-search="search"
        (keyup)="bookmarkUpdate($event)"
        [(ngModel)]="bookmarkText"
      />

      <!-- Auto Suggestion List -->
      <ul class="search-list search-list-bookmark show" [perfectScrollbar]>
        <ng-container *ngIf="bookmarkText !== ''; else defaultBookmarks">
          <li
            class="auto-suggestion"
            *ngFor="let page of pages | findBookmark : bookmarkText | slice : 0 : 6; let i = index"
            [ngClass]="{ current_item: i === activeIndex }"
          >
            <a
              class="d-flex align-items-center justify-content-between w-100"
              [routerLink]="page.link"
              (click)="
                $event.stopPropagation(); $event.preventDefault(); closeBookmark(); removeOverlay()
              "
              ><div class="d-flex justify-content-start align-items-center">
                <i class="feather icon-{{ page.icon }} mr-75"></i>
                <span>{{ page.subName }}</span>
              </div>
              <button
                type="button"
                class="btn p-0"
                (click)="$event.stopPropagation(); $event.preventDefault(); toggleBookmark(page.id)"
              >
                <i class="feather icon-star" [class.text-warning]="page.is_favoris"></i>
              </button>
            </a>
          </li>
        </ng-container>
        <ng-template #defaultBookmarks>
          <ng-container *ngFor="let page of pages | findBookmark : bookmarkText; let i = index">
            <li class="auto-suggestion" [ngClass]="{ current_item: i === activeIndex }">
              <a
                class="d-flex align-items-center justify-content-between w-100"
                [routerLink]="page.link"
                (click)="
                  $event.stopPropagation();
                  $event.preventDefault();
                  closeBookmark();
                  removeOverlay()
                "
                ><div class="d-flex justify-content-start align-items-center">
                  <i class="feather icon-{{ page.icon }}" class="mr-75"></i>
                  <span>{{ page.subName }}</span>
                </div>
                <button
                  type="button"
                  class="btn p-0"
                  (click)="
                    $event.stopPropagation(); $event.preventDefault(); toggleBookmark(page.id)
                  "
                >
                  <i class="feather icon-star" [class.text-warning]="page.is_favoris"></i>
                </button>
              </a>
            </li>
          </ng-container>
        </ng-template>
      </ul>
      <!--/ Auto Suggestion List -->
    </div>
    <!--/ Bookmark Pop-up -->
  </li>
</ul>
